import React, { useState, useEffect } from 'react';
import NavLinks from '../Navbar/NavLinks';
import { HashLink } from 'react-router-hash-link';
import { useNavigate } from 'react-router-dom';


const NavBar = () => {
    const [top, setTop] = useState(true);
    const [isOpen, setisOpen] = React.useState(false);
    const [member, setMember] = useState(null);
    const navigate = useNavigate();
    function handleClick() {
        setisOpen(!isOpen);
    }

    useEffect(() => {
      const syncMember = () => {
        try {
          setMember(JSON.parse(localStorage.getItem('zelt_member') || 'null'));
        } catch (e) {
          localStorage.removeItem('zelt_member');
          setMember(null);
        }
      };
      syncMember();
      window.addEventListener('zelt-auth', syncMember);
      window.addEventListener('storage', syncMember);
      return () => {
        window.removeEventListener('zelt-auth', syncMember);
        window.removeEventListener('storage', syncMember);
      };
    }, []);

    const handleLogout = () => {
      localStorage.removeItem('zelt_token');
      localStorage.removeItem('zelt_member');
      setMember(null);
      window.dispatchEvent(new Event('zelt-auth'));
      navigate('/');
    }


    useEffect(() => {
      const scrollHandler = () => {
        window.pageYOffset > 10 ? setTop(false) : setTop(true)
      };
      window.addEventListener('scroll', scrollHandler);
      return () => window.removeEventListener('scroll', scrollHandler);
    }, [top]);

    return (
        <nav className={`fixed top-0 w-full z-30 transition duration-300 ease-in-out mb-16 ${!top && 'bg-white shadow-lg shadow-purple-300/50'}`}>
            <div className="flex flex-row justify-between items-center py-2">
                <div className="flex flex-row justify-center md:px-5 md:mx-5 items-center text-center font-semibold">
                    <HashLink smooth to="/#hero"><h1 className="font-extrabold text-2xl lg:text-3xl text-blue-900 whitespace-nowrap">ZelTechnology</h1></HashLink>
                    
                </div>
                <div className="flex flex-col items-center">
                    <button className="p-2 rounded-lg lg:hidden text-blue-900" onClick={handleClick}>
                        <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            {isOpen && (
                            <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                            )}
                            {!isOpen && (
                            <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                            )}
                        </svg>
                    </button>
                    <div className='hidden lg:flex items-center whitespace-nowrap px-4'>
                        <NavLinks member={member} onLogout={handleLogout} />
                    </div>

                    <div className={`fixed transition-transform duration-300 ease-in-out transit flex justify-center left-0 w-full h-auto rounded-md p-24 bg-white lg:hidden shadow-xl top-14 ${  isOpen ? "block" : "hidden" } `}>
                        <div className='flex flex-col space-y-6'>
                            <NavLinks member={member} onLogout={handleLogout} />
                        </div>
                    </div>

                </div>
            </div>
        </nav>
    )
    
}


export default NavBar;
